/**
 * 鉴权相关 API 服务（CLAUDE.md §前端 API 服务层 — 按域分目录）。
 */

import { ApiError, request, setToken } from "./apiClient";

export interface LoginResponse {
  token: string;
  user_id: string;
}

export interface LoginBody {
  account: string;
  password: string;
}

export async function login(body: LoginBody): Promise<LoginResponse> {
  const data = await request<LoginResponse>("/api/v1/auth/login", {
    method: "POST",
    body,
  });
  if (data?.token) setToken(data.token);
  return data;
}

export async function logout(): Promise<void> {
  try {
    await request<{ revoked: boolean }>("/api/v1/auth/logout", { method: "POST" });
  } catch (e) {
    // 注销失败不影响本地清理
    if (!(e instanceof ApiError)) console.warn("logout error", e);
  }
  setToken(null);
}

/** 当前用户编辑权限（GET /api/v1/auth/permissions）。前端据此禁用无权限页面的编辑 UI。 */
export interface MyPermissions {
  user_id: string | null;
  editable_pages: string[];
  is_admin: boolean;
}

export async function getMyPermissions(): Promise<MyPermissions> {
  return request<MyPermissions>("/api/v1/auth/permissions");
}